import { PageContextProvider } from "../../../context/PageContext";
import { PlayerToolbarContextProvider } from "../../../context/PlayerToolbarContext";
import Page from "./Page";

function PageLoader({page}){
    return (
        <PageContextProvider page={page}>
            <PlayerToolbarContextProvider>
                <Page />
            </PlayerToolbarContextProvider>               
        </PageContextProvider>
    )
}
export default PageLoader;